import { ITariff } from "@interfaces/admin/tariff";
import { authApi } from "@RTKQuery/basic";

const tariffsAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getAdminTariffs: build.query<ITariff[], void>({
            query: () => "tariffs",
        }),
        updateTariffPrices: build.mutation<ITariff, {
            tariff_id: ITariff["id"],
            data: ITariff["rental_periods"]
        }>({
            query: ({ tariff_id, data }) => ({
                url: `tariffs/${tariff_id}/update_prices`,
                method: "PUT",
                body: data
            }),
            async onQueryStarted({ tariff_id }, { dispatch, queryFulfilled }) {
                try {
                    const { data: newData } = await queryFulfilled;

                    dispatch(tariffsAuthApi.util.updateQueryData("getAdminTariffs", undefined, (draft) => {
                        return draft.map(item => {
                            if (item.id === tariff_id) {
                                return newData
                            } else {
                                return item;
                            }
                        })
                    }))
                } catch { }
            },
        })
    }),
    overrideExisting: false,
})

export const {
    useGetAdminTariffsQuery,
    useUpdateTariffPricesMutation
} = tariffsAuthApi;